/*
 * --------------------------------------------------------
 *  Contain all url needed to make call to the application
 * --------------------------------------------------------
 */

/* MAIN_URL_TO_CALL */
export const SENSOR_DATA_DOMAIN = process.env.VUE_APP_TIRANAMOBILITY_URL;
export const VODAFONE_URL = "https://www.vodafone.al/en/";
export const BASHKIA_TIRANE_URL = "https://www.tirana.al/";
/* export const APRTIRANA_URL =
  "https://aprtirana.al/une-dhuroj/dhuro-nje-peme/dhuro-peme-si-individ/"; */
export const APRTIRANA_URL =
	"https://aprtirana.al/dhuro-peme-per-tiranen-2021-2022/";

/* REGISTER USER */
export const REGISTER_USER = "livetraffic/notifications/userRegister.php";

/* TRAFIC */
export const ROUTES_DATA_MAP_TRAFFIC =
	"livetraffic/mapdata/getMeasurements.php?callback=JSON_CALLBACK";
export const MARKERS_MAP_DATA_CCTV = "livetraffic/mapdata/getCCTV.php";

/* TRANSPORT */
export const PUBLIC_TRANSPORT_URBAN =
	"livetraffic/mapdata/getPublicTransportV2.php?callback=JSON_CALLBACK";
export const PUBLIC_TRANSPORT_INTERURBAN =
	"livetraffic/mapdata/getInterurbanTransportV2.php?callback=JSON_CALLBACK";
export const GET_STREET =
	"livetraffic/mapdata/getStreets.php?callback=JSON_CALLBACK";
export const GET_BICYCYLES =
	"livetraffic/mapdata/getBicyclesV2.php?callback=JSON_CALLBACK";
export const GET_NOTIFICATIONS_LIST =
	"livetraffic/notifications/getNotificationList.php?callback=JSON_CALLBACK";

/** SETTINGS */
export const GET_SETTINGS =
	"livetraffic/notifications/getUserSettings.php?userID=";
export const POST_SETTINGS = "livetraffic/notifications/postUserSettings.php";

/* PARKING */

//  Todo change  uncomment "parkimet/ParkingInfo.php?callback=JSON_CALLBACK&lng=1";
//  comment "tirana_parking/WS/ParkingInfo.php";
// export const GET_PARKING_STREETS = "parkimet/ParkingInfo.php?lng=";

//export const GET_PARKING_STREETS = "tirana_parking/WS/ParkingInfo.php";
//export const GET_PARKING_STREETS = "parkimet/ParkingInfo.php";
export const GET_PARKING_STREETS = "parkimet/ParkingInfoV2.php";

export const GET_STREET_LOAD =
	"parkimet/ParkingInfo_VendeTeLira.php?callback=JSON_CALLBACK";
export const GET_PARKING_STREET_TO_PAY =
	"parkimet/ParkingInfo.php?callback=JSON_CALLBACK&kordinatat=N";
export const GET_PARKING_NO_STREET =
	"parkimet/getParking-nostreet.php?callback=JSON_CALLBACK";
export const GET_TAXI = "taxi/getTaxi.php";

/* POI */
export const GET_POI = "poi/getPoiV3.php?callback=JSON_CALLBACK&lng=";
export const GET_POI_TURISEM = "indexJson.php?ap_prcss=poiDetails&k=";
export const GET_RESTAURANTS = "poi/getRestaurants.php";

/* REPORT */
export const POST_REPORT = "raportime/postRaportim.php";
export const GET_REPORT_CATEGORIES =
	"raportime/getRaportimKategorite.php?callback=JSON_CALLBACK";

export const GET_USER_REPORTS = "raportime/getUserReports.php";
export const GET_RAPORTS_STATUS =
	"raportime/getRaportimStatuses.php?callback=JSON_CALLBACK";
export const GET_PUBLIC_REPORTS =
	"raportime/getPublicReports.php?callback=JSON_CALLBACK";

export const GET_REPORT_LIMIT =
	"raportime/raportimeLimit.php?callback=JSON_CALLBACK";
export const GET_REPORT_IMAGES =
	"raportime/getReportImage.php?callback=JSON_CALLBACK&id=";

/* INFO */
export const GET_INFO = "info/getInfo.php";

export const GET_NJESIT = "info/getNjesite.php";
export const GET_FSHATRAT = "info/getFshatrat.php";
export const GET_NJESITE_LAYERS =
	"info/getNjesiteLayers.php?callback=JSON_CALLBACK";
export const GET_NDERRMARJET = "info/getNdermarrjet.php?callback=JSON_CALLBACK";
export const GET_KOPSHTET = "info/getKopshtet.php";
export const GET_SHKOLLAT = GET_POI;
// export const GET_SHKOLLAT = "info/getShkollat.php";
export const GET_SHKOLLAT_COMUNITY =
	"info/getShkollatKom.php?callback=JSON_CALLBACK";
export const GET_ADRESS_LIVE_TRAFIC =
	"livetraffic/mapdata/getAddress.php?latlng=";

/* AIR_QUALITY */
export const GET_AIR_QUALITY_HISTORICAL = "airquality/historicaldata.php?id=";
export const GET_AIR_QUALITY = "airquality/_index.php";
export const GET_AIR_TEMPERATURE_WIND = "airquality/get_temp_wind.php";

/* Terms & Conditions */
export const TERMS_CONDITIONS_URL = {
	1: "https://tiranamobility.altirana.com/policy/terms/?embed=true",
	2: "https://tiranamobility.altirana.com/policy/terms/en/?embed=true",
};
export const PRIVACY_POLICY_URL = {
	1: "https://tiranamobility.altirana.com/policy/?embed=true",
	2: "https://tiranamobility.altirana.com/policy/en/?embed=true",
};

/* Tirana XXL */
export const TIRANA_XXL_API = "cityevents/getCityEvents.php";

/* Tirana EYC */
//export const TIRANA_EYC_EVENTS = 'https://tiranaeyc2022.al/wp-json/mecexternal/v1/calendar/2125'
export const TIRANA_EYC_EVENTS = "tiranaeyc/getEYCEvents.php";

// NEW IMPLEMENTATION URLS, TO BE CHANGED IN THE FUTURE

/* Base URL */
export const BASE_URL = "http://172.16.203.227:10123";

//ORGANISATION URL

// export const ORGANISATION_LIST_URL = "http://localhost:4010/v1/organisations";

export const ORGANISATION_LIST_URL = `${BASE_URL}/v1/organisations`;

export const ORGANISATION_DETAILS_URL = `${BASE_URL}/v1/organisations/`;

// export const ORGANISATION_DETAILS_URL =
// 	`http://localhost:4010/v1/organisations/{id}`;

export const ORGANISATION_FORM_URL = `${BASE_URL}/v1/messages?to=Organisation`;

//VOLUNTEERING URL

// export const VOLUNTEERING_LIST_URL =
// 	`http://localhost:4010/v1/volunteering/initiatives`;

export const VOLUNTEERING_LIST_URL = `${BASE_URL}/v1/volunteering/initiatives`;

// export const VOLUNTEERING_DETAILS_URL =
// 	`http://localhost:4010/v1/volunteering/initiatives/{id}`;

export const VOLUNTEERING_DETAILS_URL = `${BASE_URL}/v1/volunteering/initiatives/`;

export const VOLUNTEERING_FORM_URL_TOPIC = `${BASE_URL}/v1/volunteering/applicants/topic`;

export const VOLUNTEERING_TOPIC_URL = `${BASE_URL}/v1/topics?tag=Initiative`;

export const VOLUNTEERING_FORM_URL_INITIATIVE = `${BASE_URL}/v1/volunteering/applicants`;

export const VOLUNTEERING_FORM_URL_VERIFY = `${BASE_URL}/v1/volunteering/applicants/verification`;

export const VOLUNTEERING_APPLICATION_LIST_URL = `../../../../sampleJSON/volunteeringApplications.json`;

//DONATIONS URL

export const DONATIONS_LIST_URL = `${BASE_URL}/v1/foundations`;

export const DONATIONS_DETAILS_URL = `${BASE_URL}/v1/foundations/`;

export const DONATION_FORM_URL = `${BASE_URL}/v1/messages?to=Foundation`;

//DORMITORY URL

/* Base URL from dormitory service backend*/
export const BASE_URL_DORMITORY = "https://rsu.altirana.com/nes/tsr";

export const DORMITORY_ACCESS_URL = `${BASE_URL_DORMITORY}/rezervim_aktiv`;
//export const DORMITORY_FORM_DATA_URL = `${BASE_URL_DORMITORY}/v1/basedata_front/?source=district%2Cviti_shkollor%2Cstatusi_punesimit&sort_by=id`;
export const DORMITORY_FORM_DATA_URL = `${BASE_URL_DORMITORY}/basedata_front`;

export const DORMITORY_BUILDING_URL = `${BASE_URL_DORMITORY}/vende_te_lira_kg/1`;
export const DORMITORY_ROOM_URL = `${BASE_URL_DORMITORY}/vende_te_lira_dh/1`;
export const DORMITORY_POST_URL = `${BASE_URL_DORMITORY}/rezervim`;
